<script setup lang="ts">
import { KDropdown, KSelectWrapper } from "@kaleidoscope-solutions/ks-design-system"
import { ListIcon } from "@kaleidoscope-solutions/ks-icons/vue/light"

interface Props {
  importTargets: string[]
}
defineProps<Props>()

const target = defineModel<string>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <label>
        <strong class="font-bold">Upload</strong>
      </label>

      <KDropdown
        v-model="target"
        placeholder="Find"
        :items="importTargets"
        :nullable="false"
        :multiple="false"
        class="w-52 bg-white"
      >
        <template #selected="{ open, selected }">
          <div class="w-full">
            <KSelectWrapper
              :open="open"
              class="w-full"
              data-test="import-target-dropdown-btn"
            >
              <span v-if="selected">{{ selected }}</span>
              <span
                v-else
                class="text-gray-700"
              >
                Please select
              </span>
            </KSelectWrapper>
          </div>
        </template>
        <template #item="{ item }">
          <div class="flex w-full items-center gap-1">
            <ListIcon class="size-5 shrink-0" />
            <span>{{ item.label }}</span>
          </div>
        </template>
      </KDropdown>
    </div>
  </div>
</template>
